import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FeeCalculator = () => {
  const [amount, setAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('ach');

  const paymentMethods = [
    { value: 'ach', label: 'ACH Bank Transfer', fee: 0, processingTime: '3-5 business days' },
    { value: 'wire', label: 'Wire Transfer', fee: 25, processingTime: '1-2 business days' },
    { value: 'debit', label: 'Debit Card', fee: 3.99, processingTime: 'Instant' },
    { value: 'credit', label: 'Credit Card', fee: 3.99, processingTime: 'Instant' }
  ];

  const selectedMethod = paymentMethods?.find(m => m?.value === paymentMethod);
  const numAmount = parseFloat(amount) || 0;
  const feeAmount = selectedMethod?.fee === 0 ? 0 : selectedMethod?.fee;
  const totalAmount = numAmount + feeAmount;

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-[var(--color-accent)] bg-opacity-10 flex items-center justify-center">
          <Icon name="Calculator" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)]">
            Fee Calculator
          </h3>
          <p className="text-xs md:text-sm text-[var(--color-muted-foreground)]">
            Calculate transaction costs
          </p>
        </div>
      </div>
      <div className="space-y-4">
        <Input
          label="Amount (USD)"
          type="number"
          placeholder="Enter amount"
          value={amount}
          onChange={(e) => setAmount(e?.target?.value)}
          min="0"
          step="0.01"
        />

        <Select
          label="Payment Method"
          options={paymentMethods}
          value={paymentMethod}
          onChange={setPaymentMethod}
        />

        {amount && (
          <div className="mt-6 space-y-3 pt-4 border-t border-[var(--color-border)]">
            <div className="flex justify-between items-center">
              <span className="text-sm text-[var(--color-muted-foreground)]">Amount</span>
              <span className="text-sm font-semibold text-[var(--color-foreground)]">
                ${numAmount?.toFixed(2)}
              </span>
            </div>
            
            <div className="flex justify-between items-center">
              <span className="text-sm text-[var(--color-muted-foreground)]">Fee</span>
              <span className="text-sm font-semibold text-[var(--color-foreground)]">
                ${feeAmount?.toFixed(2)}
              </span>
            </div>
            
            <div className="flex justify-between items-center pt-3 border-t border-[var(--color-border)]">
              <span className="text-base font-semibold text-[var(--color-foreground)]">Total</span>
              <span className="text-base font-bold text-[var(--color-primary)]">
                ${totalAmount?.toFixed(2)}
              </span>
            </div>

            <div className="mt-4 p-3 bg-[var(--color-muted)] rounded-lg">
              <div className="flex items-start gap-2">
                <Icon name="Clock" size={16} color="var(--color-muted-foreground)" className="mt-0.5 flex-shrink-0" />
                <p className="text-xs text-[var(--color-muted-foreground)]">
                  Processing time: {selectedMethod?.processingTime}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeeCalculator;